import { render, staticRenderFns } from "./WithdrawWallet.vue?vue&type=template&id=cd29e502&scoped=true"
import script from "./WithdrawWallet.vue?vue&type=script&lang=js"
export * from "./WithdrawWallet.vue?vue&type=script&lang=js"
import style0 from "./WithdrawWallet.vue?vue&type=style&index=0&id=cd29e502&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd29e502",
  null
  
)

export default component.exports